"use client";
import * as React from "react";
const SvgBackspaceFilled = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 12", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M14.67 0h-10C4.2 0 3.85.23 3.6.59L0 6l3.6 5.4c.25.36.6.6 1.07.6h10c.73 0 1.33-.6 1.33-1.33V1.33C16 .6 15.4 0 14.67 0m-2 8.4-.94.93-2.4-2.39-2.39 2.4L6 8.38 8.4 6 6 3.6l.94-.93 2.4 2.39 2.39-2.4.94.95L10.27 6z" }));
export {
  SvgBackspaceFilled as default
};
